export const SUPORTE_PERMISSIONS = {
  dashboardRead: 'support_tickets.read',
  ticketCreate: 'support_tickets.create',
  ticketUpdate: 'support_tickets.update',
  ticketAssign: 'support_tickets.assign',
  taskManage: 'tasks.manage',
} as const;
